module.exports = __webpack_public_path__ + "assets/5529f3e7d1eabb3a49b50fae2ec54947.png";